<template></template>

<script>
import { mapState } from 'vuex';
export default {
  name: "Home",
  computed: {
    ...mapState([
      `alreadyLogged`,
      `me`,
    ]),
  },
  created () {
    this.handleAlreadyLogged();
  },
  methods: {
    handleAlreadyLogged () {
      if (this.alreadyLogged) {
        if (this.me && this.me.homeUrl) {
          return window.location.href = this.me.homeUrl;
        }
        this.redirectToLogin();
      } else if (this.alreadyLogged === false) {
        this.redirectToLogin();
      }
    },
    redirectToLogin () {
      const query = this.$route.query.from ? { r: this.$route.query.from } : null;
      this.$router.replace({ name: `Login`, query });
    },
  },
  watch: {
    alreadyLogged (val) {
      this.handleAlreadyLogged();
    },
  },
};
</script>

<style scoped>

</style>
